// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width: 700px) {\n.c-table__cell-values {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.c-table__cell-values-value {\n  padding: 10px;\n  border-bottom: solid 1px #dfe4ef;\n}\n@media screen and (max-width: 700px) {\n.c-table__cell-values-value {\n      border-bottom: none;\n      border-right: solid 1px #dfe4ef;\n}\n}\n.c-table__cell-values-value-not-border {\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
